import 'reflect-metadata';

import { injectable } from 'inversify';
import React from 'react';

import { ComponentPropsValueObject } from '../../../../shared/core/domain/ComponentPropsValueObject';
import { TAnyOfPermissionsHOC } from '../../../../shared/core/infrastructrue/types';
import { TenantSwitcherComponent } from '../ui/TenantSwitcher/TenantSwitcher.component';
import { TTenantSwitcher } from '../ui/TenantSwitcher/TenantSwitcher.view';
import { TenantTileCardComponent } from '../ui/TenantTileCard/TenantTileCard.component';
import { TTenantTileCard } from '../ui/TenantTileCard/TenantTileCard.view';

@injectable()
export class TenantComponentFactory {
  public readonly createTenantSwitcher = (
    payload: ComponentPropsValueObject<
      Omit<TTenantSwitcher, 'tenantSwitcherComponent'>
    >,
  ): React.ReactElement<TTenantSwitcher> => {
    return TenantSwitcherComponent.create(payload);
  };

  public readonly createMoveUserTenantSwitcher = (
    payload: Omit<TTenantSwitcher, 'tenantSwitcherComponent'>,
  ) => {
    return TenantSwitcherComponent.createWithNoPermissions(payload);
  };

  public readonly createTenantTileCard = (
    payload: TAnyOfPermissionsHOC<Omit<TTenantTileCard, 'config'>>,
  ): React.ReactElement<TTenantTileCard> => {
    return TenantTileCardComponent.create(payload);
  };
}
